import '@aab/sc-aab-button';
import { Icon } from '@uikit';
import { FC, MouseEvent, ReactNode, useEffect, useRef } from 'react';
import './button.module.scss';

type ButtonProps = {
  iconPosition?: 'right' | 'left';
  styleType?: 'action' | 'base' | 'secondary' | 'primary';
  fullWidth?: boolean;
  fluid?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  icon?: SVGAElement;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  iconSize?: number;
  className?: string;
};
export const Button: FC<ButtonProps> = ({
  children,
  disabled,
  fullWidth,
  fluid,
  styleType,
  icon,
  iconSize = 3,
  iconPosition,
  onClick,
  className
}) => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const { current } = ref;
    const clickHandler = disabled ? () => {} : onClick;
    if (!current || disabled) return;
    current.addEventListener('click', clickHandler as any);

    return () => current.removeEventListener('click', clickHandler as any);
  }, [ref.current, onClick, disabled]);

  return (
    <aab-button
      ref={ref}
      full-width={fullWidth || undefined}
      fluid={fluid || undefined}
      style-type={styleType}
      icon-position={iconPosition}>
      <button
        disabled={disabled || undefined}
        className={className}
        type="button">
        {icon && (
          <Icon
            svg={icon}
            size={iconSize}
            color={disabled ? '#808080' : '#00716b'}
          />
        )}
        {children}
      </button>
    </aab-button>
  );
};
